import { Icon } from '@iconify/react';
import heartIcon from '@iconify-icons/ion/heart';
import heartOutline from '@iconify-icons/ion/heart-outline';
import styles from './StudentProgressModal.module.scss';
import { getReadableUnixTimeAnsi } from '../GlobalFunctions';
import { ComprehensionDataPoint, StruggleDataPoint } from '../../peekapak-types/PeekavilleGameDataTypes';

interface Props {
  hideModal: () => void;
  struggleData: StruggleDataPoint[] | ComprehensionDataPoint[];
  level: number;
  title: string;
}

const StudentProgressModal = ({ hideModal, struggleData, level, title }: Props): JSX.Element => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <h2 className={styles.name}>
          {title} - Level&nbsp;{level}
        </h2>
        <button onClick={hideModal}>x</button>
      </div>
      <div className={styles.studentDataContainer}>
        {struggleData.map((dataPoint) => {
          const date = getReadableUnixTimeAnsi(dataPoint.createdAt);
          const rightNum = new Array(dataPoint.rightNum ?? dataPoint.numRight).fill(null);
          const wrongNum = new Array(dataPoint.wrongNum ?? dataPoint.numWrong).fill(null);
          return (
            <div className={styles.row}>
              {date}
              <div className={styles.hearts}>
                {dataPoint.rightNum === 0 && dataPoint.wrongNum === 0 ? (
                  'Complete'
                ) : (
                  <div>
                    {rightNum.map((_, index) => (
                      <Icon icon={heartIcon} width={30} key={`numberright${index}`} color={'#fb7270'} />
                    ))}
                    {wrongNum.map((_, index) => (
                      <Icon width={30} icon={heartOutline} color={'#fb7270'} key={`numberwrong${index}`} />
                    ))}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StudentProgressModal;
